import { OrderConfirmationStoredSession } from '../model';

export const getOtpRequestDelaySeconds = (
  session: OrderConfirmationStoredSession | null
) => {
  if (!session) {
    return 0;
  }
  /**
   * the time after which the user can request a new otp
   */
  const delayMs = (session.challenge.OTPMetadata?.delaySec ?? 0) * 1000;
  const allowedTime = session.lastRequestTime + delayMs;
  /**
   * the time user should wait before requesting a new otp
   */
  const delay = allowedTime - new Date().getTime();

  if (delay <= 0) {
    return 0;
  }

  return Math.floor(delay / 1000);
};
